<template>
    <div id="app">
        <Obrigado v-if="fourthStep" />

        <div class="wrapper" v-show="!fourthStep">

        <div class="mobile logo d-block d-md-none">
            <img alt="Pharmapele" src="./assets/logo.png">
        </div>

        <header>
            <div class="container">
                <div class="row">
                    <div class="col-12 d-none d-md-block">
                        <div class="logo">
                            <img alt="Pharmapele" src="./assets/logo.png">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="logo-secondary">
                            <img src="./assets/logo-secondary@2x.png" width="426" alt="">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-primary">
                            <form @submit="validateForm" autocomplete="off" id="orcamento">
<!--                                <div class="title-small">PASSO 01</div>-->

                                <input type="hidden" name="traffic_source" value="">
                                <input type="hidden" name="client_id" value="">

                                <div class="content" v-show="firstStep">
                                    <div class="title-primary">
                                        Preencha o formulário abaixo para receber o orçamento por WhatsApp ou E-mail.
                                    </div>

                                    <div class="form-group">
                                        <input name="nome" autocomplete="both" type="text" class="form-control"
                                               placeholder="NOME" :required="firstStep">
                                    </div>
                                    <div class="form-group">
                                        <input name="email" autocomplete="both" type="email" class="form-control"
                                               placeholder="E-MAIL" :required="firstStep">
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input name="telefone" autocomplete="both" type="text"
                                                       data-masked="(00) 0000-00009"
                                                       class="form-control mask-phone" placeholder="TELEFONE"
                                                       :required="firstStep">
                                            </div>
                                        </div>
                                        <!-- /.col-md-6 -->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <select name="genero" class="form-control" :required="firstStep">
                                                    <option value="">GÊNERO</option>
                                                    <option>Feminino</option>
                                                    <option>Masculino</option>
                                                    <option>Outros</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input name="nascimento" type="text" placeholder="DATA DE NASCIMENTO"
                                                       data-masked="00/00/0000"
                                                       class="form-control" :required="firstStep">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <select name="estado" class="form-control" v-model="form.estado"
                                                        :required="firstStep">
                                                    <option value="">ESTADO</option>
                                                    <option v-for="item in estados" v-bind:key="item"
                                                            v-bind:value="item">{{ item }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <select name="cidade" @click="alertState" v-model="form.franqueado"
                                                        class="form-control" :required="firstStep"
                                                        :disabled="!form.estado">
                                                    <option value="">CIDADE</option>
                                                    <option v-for="item in cidades" v-bind:key="item.id"
                                                            v-bind:value="item.id">{{ item.cidade }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-check p-policy">
                                                <input type="checkbox" class="form-check-input" id="policy1" name="policy1" required>
                                                <label class="form-check-label" for="policy1">
                                                  Concordo que meus dados poderão ser utilizados para um atendimento
                                                  personalizado que possibilitará o envio de comunicação de ofertas e
                                                  serviços de acordo com os meus interesses, pelos meios que
                                                  disponibilizei no formulário. A qualquer momento eu poderei me
                                                  descadastrar do recebimento. Para mais detalhes consulte nossa <a
                                                    target="_blank"
                                                    href="https://www.pharmapele.com.br/politica-de-privacidade">Política
                                                  de Privacidade.</a>
                                                </label>
                                            </div>
                                        </div>
                                        <!-- /.col-md-12 -->

                                    </div>

                                    <button class="btn btn-success" type="submit">
                                        CONTINUAR
                                        <img src="./assets/arrow-right.svg" alt="">
                                    </button>

                                </div>
                                <!-- .content -->

                                <div class="content second" v-if="secondStep">
                                    <div class="title-primary">
                                        Preencha o formulário abaixo para receber o orçamento por WhatsApp ou E-mail.
                                    </div>
                                    <p>
                                        Selecione a melhor forma para receber o orçamento:
                                    </p>
                                    <a v-bind:href="'https://wa.me/55'+franqueadoAtual.whatsapp+'?text=Olá, entrei no site da Pharmapele e gostaria de solicitar um orçamento online.'"
                                       target="_blank" class="btn btn-success"
                                       v-if="franqueadoAtual && franqueadoAtual.whatsapp">
                                        WHATSAPP
                                    </a>
                                    <br><br>
                                    <button type="submit" class="btn btn-success">
                                        E-MAIL
                                    </button>

                                </div>
                                <!-- /.content -->

                                <div class="content third" v-show="thirdStep">
                                    <div class="title-primary">
                                        Preencha o formulário abaixo para receber o orçamento por WhatsApp ou E-mail.
                                    </div>

                                    <p>
                                        Anexe sua receita ou escreva qual manipulado para receber seu orçamento por e-mail.
                                    </p>

                                    <label for="">ANEXAR RECEITA <span>( Foto ou PDF )</span></label>
                                    <div class="input-wrapper">
                                        <input class="form-control" @change="validateFile" type="file" name="file"
                                               accept="image/jpeg,image/png,.pdf" value="Enviar">
                                    </div>
                                    <!-- /.input-wrapper -->


                                    <p class="receita">
                                        <span class="form-group">
                                            <label for="">MANIPULADO SEM RECEITA</label>
                                            <textarea name="receita" maxlength="500" id="" cols="30" rows="3"
                                                      class="form-control"></textarea>
                                            <!-- /#.form-control -->
                                        </span>
                                        <!-- /.form-group -->
                                    </p>



                                    <button :disabled="isLoading" type="submit" class="btn btn-success" v-show="!isLoading">
                                        QUERO RECEBER O ORÇAMENTO
                                    </button>

                                    <button :disabled="isLoading" type="submit" class="btn btn-success" v-show="isLoading">
                                        ENVIANDO AGUARDE...
                                    </button>


                                </div>
                                <!-- /.content -->

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="steps">
            <div class="container">
                <div class="box">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="./assets/passo01@2x.png" width="120" alt="Passo 01">

                            <div class="right">
                                <div class="title-small">PASSO 01</div>
                                <div class="title-primary">
                                    Escolha a pharmapele mais próxima de você
                                </div>
                            </div>
                            <!-- /.right -->

                        </div>
                        <div class="col-md-4">
                            <img src="./assets/passo02@2x.png" width="120" alt="Passo 02">

                            <div class="right">
                                <div class="title-small">PASSO 02</div>
                                <div class="title-primary">
                                    Realize seu pedido: medicamentos, suplementos ou dermocosméticos.
                                </div>
                            </div>
                            <!-- /.right -->

                        </div>
                        <div class="col-md-4">
                            <img src="./assets/passo03@2x.png" width="120" alt="Passo 03">
                            <div class="right">
                                <div class="title-small">PASSO 03</div>
                                <div class="title-primary last">
                                    Entregamos o pedido aonde você estiver.
                                </div>
                            </div>
                            <!-- /.right -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.steps -->

        <div class="about">
            <div class="container text-center">


                <div class="title-small">QUEM SOMOS</div>

                <div class="title-primary">
                    A Pharmapele é a maior rede de Farmácias de Manipulados, com mais de 130 lojas pelo Brasil e 34 anos de
                    experiência em medicamentos personalizados, suplementos e cosméticos de tratamento.
                </div>
                <!-- /.title-primary -->

                <p>
                    O DNA da Pharmapele vem metade das fórmulas personalizadas prescritas pelos médicos, da precisão
                    científica, dos laboratórios. A outra metade vem da beleza, da jovialidade, do bem estar que se
                    reflete no rosto e no corpo.
                </p>

                <a href="#orcamento" class="btn btn-success">SOLICITAR ORÇAMENTO</a>
                <!-- /.btn btn-success -->

            </div>
            <!-- /.container -->
        </div>
        <!-- /.about -->

        <div class="video">
            <div class="container text-center">
                <div class="box-video">
                    <img src="./assets/bg-video.png" alt="Vídeo">
                    <a @click="openVideo" href="#play" class="play">
                        <img src="./assets/btn-play.png" alt="">
                    </a>
                    <!-- /.play -->
                </div>
                <!-- /.box-video -->
            </div>
            <!-- /.container text-center -->
        </div>
        <!-- /.video -->

        <footer>
            <div class="container text-center icons">
                <div class="row">
                    <div class="col-md-4 col-6">
                        <img class="ico" src="./assets/ico-pharmacy.svg" alt="">
                        <p>Fomos pioneiros na criação do Centro de Excelência Farmacêutica com pesagem
                            computadorizada.</p>
                    </div>
                    <!-- /.col-md-4 -->
                    <div class="col-md-4 col-6">
                        <img class="ico" src="./assets/ico-brazil.svg" alt="">
                        <p>130 Lojas em todas as 5 regiões do país.</p>
                    </div>
                    <!-- /.col-md-4 -->
                    <div class="col-md-4">
                        <img class="ico last" src="./assets/ico-abf@2x.png" width="114" alt="">
                        <p>Somos a única Farmácia de Manipulados do Brasil a receber o Selo de Excelência por 15
                            anos.</p>
                    </div>
                    <!-- /.col-md-4 -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container -->
            <div class="credits">
                <div class="container">
                    <div class="powered">
                        <span>
                            &copy; PHARMAPELE. Todos os direitos reservados. Industrializados: Salute | CNPJ: 05.954.369.001-0001-57 Manipulados: GRADAR produtos farmacêuticos | CNPJ: 12.8096.626.0002-50
                        </span>
                        <a href="https://boldcomunicacao.com.br/" target="_blank">
                            <img src="./assets/its-dare.svg" alt="Bold">
                        </a>
                    </div>
                    <!-- /.powered -->
                </div>
                <!-- /.container -->
            </div>
            <!-- /.credits -->
        </footer>
        </div>
        <!-- /.wrapper -->

        <!--        <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    </div>
</template>

<script>
    import "lity/dist/lity.min.css";
    import "bootstrap/dist/css/bootstrap.min.css";
    import $ from "jquery";
    import "jquery-mask-plugin";
    import lity from "lity";
    import Obrigado from './components/Obrigado.vue'

    const API_URL = /localhost/.test(location.hostname)
        ? 'https://orcamento.pharma.test/api' : '//orcamento-api.pharmapele.com.br/api';

    export default {
        name: 'Pharmepele',
        components: {
            Obrigado
        },
        data() {
            return {
                isLoading: false,
                step: 1,
                franqueados: [],
                form: {
                    estado: '',
                    franqueado: '',
                }
            }
        },
        watch: {
            'form.estado': function (){
                if (this.form){
                    this.form.franqueado = '';
                }
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {

            $('[data-masked]').each(function () {
                $(this).mask($(this).attr('data-masked'), {clearIfNotMatch: true});
            })
        },
        computed: {
            firstStep() {
                return this.step === 1;
            },
            secondStep() {
                return this.step === 2;
            },
            thirdStep() {
                return this.step === 3;
            },
            fourthStep() {
                return this.step === 4;
            },
            estados() {
                let estados = this.franqueados.reduce((acc, current) => {
                    if (!acc[current.estado]) {
                        acc[current.estado] = 1;
                    }
                    return acc;
                }, {});
                return Object.keys(estados);
            },
            cidades() {
                if (this.form.estado === "") {
                    return [];
                }
                return this.franqueados.filter((current) => {
                    return current.estado === this.form.estado;
                });
            },
            franqueadosById() {
                let res = {};
                this.franqueados.forEach((item) => {
                    res[item.id] = item;
                });
                return res;
            },
            franqueadoAtual() {
                return this.franqueadosById[this.form.franqueado];
            }

        },
        methods: {
            openVideo(event) {
                event.preventDefault();
                lity('https://www.youtube.com/watch?v=z3R6oeV98Ys?rel=0&autoplay=1&modestbranding=0&showinfo=0');
            },
            goToNextStep() {
                this.step += 1;
            },
            alertState() {
                if (this.form.estado === '') {
                    alert('Escolha um estado primeiro.');
                }
            },
            validateForm(event) {
                event.preventDefault();

                try{
                    $('input[name="traffic_source"]').val( this._getCookie('__trf.src') );
                    $('input[name="client_id"]').val(
                        JSON.parse(decodeURIComponent(this._getCookie('rdtrk'))).id
                    );

                }catch (e) {
                    console.log('RD: cookie not found');
                }

                if (this.firstStep) {
                    this.goToNextStep();
                    this.sendRDlead()
                }else if (this.secondStep) {
                    this.goToNextStep();
                } else {
                    this.submitForm();
                }
            },
            fetchData() {
                $.get(`${API_URL}/franqueados?orcamento=1`, (res) => {
                    this.franqueados = res;
                }).fail(() => {
                    alert('Não foi possível carregar os dados, atualize a página e tente novamente.')
                });
            },
            validateFile(event) {
                let input = event.target;
                if (input.files.length > 0) {
                    let file = input.files[0];
                    let size = (file.size / 1024) / 1024;
                    //size = size.toFixed(2);

                    if (size > 10) {
                        alert("Arquivo muito grande, por gentileza, escolha um arquivo com no máximo 10mb.");
                        input.value = '';
                    }

                }
            },
            sendRDlead() {
                $.post(`${API_URL}/register`, $("form#orcamento").serializeArray())

            },
            submitForm() {
                if (
                    $('input[type=file]').val() === '' &&
                    $('textarea[name=receita]').val() === ''
                ){
                    return alert('Anexe uma receita ou escreva quais são os manipulados.');

                }
                this.isLoading = true;
                $.ajax({
                    type: 'POST',
                    url: `${API_URL}/upload`,
                    data: new FormData($("form#orcamento")[0]),
                    processData: false,
                    contentType: false,
                    success: () => {
                        // this.isLoading = false;
                        this.goToNextStep();
                    },
                    fail: () => {
                        this.isLoading = true;
                        alert('Não foi possível processar sua solicitação, tente novamente mais tarde.');
                    }
                });
            },
            _getCookie(name) {
                let value = "; " + document.cookie;
                let parts = value.split("; " + name + "=");
                if (parts.length === 2) return parts.pop().split(";").shift();
            },
        }
    }
</script>

<style lang="scss">
    @import "style/main";

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
    }

    @media (min-width: 1200px) {
        .container, .container-lg, .container-md, .container-sm, .container-xl {
            max-width: 1366px;
        }
    }
</style>
